import { render, staticRenderFns } from "./DragUploadFile.vue?vue&type=template&id=42eb11c4"
import script from "./DragUploadFile.vue?vue&type=script&lang=js"
export * from "./DragUploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports